const baseColors = [
  "#3454d1", "#1565c0", "#1976d2", "#1e88e5", "#2196f3",
  "#42a5f5", "#64b5f6", "#90caf9", "#aad6fa"
];

export const leadsOverviewChartOptions = (leadSummary=[]) => {
    if (!Array.isArray(leadSummary)) leadSummary = [];

 if (leadSummary.length === 0) {
    return {
      series: [],
      labels: [],
      // other options add
    };
  }

  const series = leadSummary.map(item => Number(item.TotalLeads));
  const labels = leadSummary.map(item => item.LeadType);

  return {
    dataLabels: {
      enabled: false
    },
    series: series,
    labels: labels,
    colors: baseColors.slice(0, series.length), // use colors matching length
    stroke: {
      width: 0,
      lineCap: "round"
    },
    legend: {
      show: false,
      position: "bottom",
      fontFamily: "Inter",
      fontWeight: 500,
      labels: {
        colors: "#A0ACBB",
        fontFamily: "Inter"
      },
      markers: {
        width: 10,
        height: 10
      },
      itemMargin: {
        horizontal: 20,
        vertical: 5
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: "85%",
          labels: {
            show: false,
            name: {
              show: false,
              fontSize: "16px",
              colors: "#A0ACBB",
              fontFamily: "Inter"
            },
            value: {
              show: false,
              fontSize: "30px",
              fontFamily: "Inter",
              color: "#A0ACBB",
              formatter: function (e) {
                return e;
              }
            }
          }
        }
      }
    },
    responsive: [{
      breakpoint: 380,
      options: {
        chart: {
          width: 280
        },
        legend: {
          show: false
        }
      }
    }],
    tooltip: {
      y: {
        formatter: function (e) {
          return +e ;
        }
      },
      style: {
        colors: "#A0ACBB",
        fontFamily: "Inter"
      }
    }
  };
};
